import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./SAdminSidebar.scss";
import { BiChevronDown } from "react-icons/bi";
import {
  FiTruck,
  FiSettings,
  FiPlusSquare,
  FiFile,
  FiHome
} from "react-icons/fi";
import { withTranslation } from "react-i18next";

const SAdminSidebar = ({ t }) => {
  const [activeOpen,setActiveMenuOpen] = useState(null);
  return (
    <div className="SAdminSidebar">
      <ul>
        <li>
          <NavLink to="#" onClick={() => setActiveMenuOpen(null)}>
            <div className="SB_icon 2">
              <FiHome />
            </div>
            Dashboard
          </NavLink>

        </li>
        <li>
          <NavLink to="list_company" onClick={() => setActiveMenuOpen(null)}>
            <div className="SB_icon">
              <FiTruck />
            </div>
            Company
          </NavLink>
        </li>
        <li>
          <NavLink to="assessments" onClick={() => setActiveMenuOpen(null)}>
            <div className="SB_icon">
              <FiFile />
            </div>
            Assessments
          </NavLink>

        </li>
        <li>
          <NavLink to="subscriptions" onClick={() => setActiveMenuOpen('subscriptions')}>
            <div className="SB_icon">
              <FiPlusSquare />
            </div>
            Subscriptions
            <div className="Drop_down_Sub">
              <BiChevronDown />
            </div>
          </NavLink>
          <ul className={`Sub_link ${activeOpen==='subscriptions' ? "show-submenu" : "hide-submenu"}`}>
            <li>
              <NavLink to="subscriptions">
                <div className="SB_icon">
                  <FiPlusSquare />
                </div>
                Subscription Plans
              </NavLink>
            </li>
            <li>
              <NavLink to="assign_subscription">
                <div className="SB_icon">
                  <FiPlusSquare />
                </div>
                Assign Subscriptions
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink to="settings" onClick={() => setActiveMenuOpen('settings')}>
            <div className="SB_icon">
              <FiSettings />
            </div>
            Settings
            <div className="Drop_down_Sub">
              <BiChevronDown />
            </div>
          </NavLink>
          <ul className={`Sub_link ${activeOpen==='settings' ? "show-submenu" : "hide-submenu"}`}>
            <li>
              <NavLink to="settings">
                <div className="SB_icon">
                  <FiSettings />
                </div>
                Risk Configuration
              </NavLink>
            </li>            
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default withTranslation()(SAdminSidebar);
